<template>
  <div>
    <div v-if="Lib.checkPower('beauty-4-cktchkfx',2)">
      <date-picker @selectDate="onChangeTime" />
      <div class="btnL">
        <el-button type="primary" @click="onDownload">导出报表</el-button>
        <el-button type="primary" @click="onPrint">打印报表</el-button>
      </div>
      <el-table tooltip-effect="light" :data="tableData" style="width: 100%;margin-bottom: 58px; margin-top :20px" @sort-change="sortChange">
        <el-table-column type="index" width="50" label="排名">
          <template slot-scope="scope">
            {{ scope.$index*1+1 + (pageNum*1-1)*10 }}
          </template>
        </el-table-column>
        <el-table-column prop="vipCardName" label="套餐名称" width="140">
          <template slot-scope="scope">
            <el-popover v-if="(scope.row.status == -1) || (scope.row.status == 1)" placement="bottom-start" trigger="hover">
              <p style="padding: 10px;">{{ scope.row.status == -1 ? '该套餐已删除' : '该套餐已停售' }}</p>
              <img v-if="scope.row.status == -1" slot="reference" class="commonTextIcon" src="static/images/icon/icon_del.png" />
              <img v-else slot="reference" class="commonTextIcon" src="static/images/icon/icon_stop.png" />
            </el-popover>
            <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
              <div slot="content">
                <p>{{ scope.row.vipCardName }}</p>
              </div>
              <span class="commonTableShow" :style="((scope.row.status == -1) || (scope.row.status == 1)) ? 'width: 100px;' : 'width: 120px;'" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.vipCardName }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="包含项目产品数量">
          <template slot-scope="scope">
            <span v-show="scope.row.num >0">项目x{{ scope.row.num }}&nbsp;&nbsp;</span>
            <span v-show="scope.row.Pnum >0">产品x{{ scope.row.Pnum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="vipCardPrice" label="套餐价格"></el-table-column>
        <el-table-column prop="duringSellNum" sortable>
          <template slot="header" slot-scope="scope">
            期间销售量
            <el-tooltip v-show="scope" class="item" effect="light" :content="'查询条件期间范围内，套餐销售量'" placement="right">
              <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="earlySellNum" sortable>
          <template slot="header" slot-scope="scope">
            期初未划扣总数
            <el-tooltip v-show="scope" class="item" effect="light" :content="'截止查询条件开始日期前，已售套餐的套餐内产品、项目的剩余未划扣的数量'" placement="right">
              <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="duringQualityNum" sortable>
          <template slot="header" slot-scope="scope">
            期间套餐内总数
            <el-tooltip v-show="scope" class="item" effect="light" :content="'查询条件期间范围内，已售套餐的套餐内产品、项目的销售数量总和：（套餐内包含的项目数量+产品数量）× 期间销售量'" placement="right">
              <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="duringDeductNum" sortable>
          <template slot="header" slot-scope="scope">
            期间划扣总数
            <el-tooltip v-show="scope" class="item" effect="light" :content="'查询条件期间范围内，套餐内产品、项目的划扣数量总和：套餐内包含的项目划扣量+产品划扣量'" placement="right">
              <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="lastSellNum" sortable>
          <template slot="header" slot-scope="scope">
            期末剩余未划扣总数
            <el-tooltip v-show="scope" class="item" effect="light" :content="'截止查询条件结束日期前，已售套餐的套餐内产品、项目的剩余未划扣的数量：期初未划扣总数+期间套餐内总数-期间划扣总数'" placement="left">
              <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.lastSellNum }}</span>
          </template>
        </el-table-column>
      <!-- <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="details(scope.row.vipCardId ,scope.row.vipCardName)">详情</el-button>
        </template>
      </el-table-column> -->
      </el-table>
      <div v-if="tableData.length > 0" class="allFooter">
        <el-pagination background :current-page.sync="pageNum" :page-size="pageSize" :page-sizes="[5, 10, 15, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        <i class="iconfont backTop" @click="Lib.backTop()">&#xe62f;</i>
      </div>
      <el-dialog :title="vipCardName" :visible.sync="PackageDialog" :append-to-body="true" width="1000px">
        <yzOrderPackage :package-data="PackageData" :package-dialog="PackageDialog" @tansferDialog="getDialogData" />
      </el-dialog>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>
<script>
import dayjs from 'dayjs';
// import {
//   getVipCardAnalyse, // (5.2)套餐划扣详情
//   getVipCardsDeduct, // (5.2)套餐划扣
// } from '../api';
import api from '../api/index';
import yzOrderPackage from '../../stage/template/orderPackage/index';

export default {
  components: {
    yzOrderPackage,
  },
  data() {
    return {
      time: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      tableData: [],
      pageNum: 1,
      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
      sortKeyWord: 3,
      sortType: 0,
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        }
      },
      headerData: {},
      PackageData: {},
      PackageDialog: false,
      vipCardName: '',
      tooltipStatus: false, // 气泡显示
    };
  },
  activated() {
    // this.getTableData(1);
  },
  methods: {
    // 排序
    sortChange({ column, prop, order }) {
      if (!column && !prop && !order) {
        this.sortKeyWord = 3;
        this.sortType = 0;
      } else {
        if (order === 'descending') {
          this.sortType = 0;
        } else {
          this.sortType = 1;
        }
        if (prop === 'packageCount') {
          this.sortKeyWord = 0;
        } else if (prop === 'itemAndProductCount') {
          this.sortKeyWord = 1;
        } else if (prop === 'itemAndProductDeductCount') {
          this.sortKeyWord = 2;
        } else if (prop === 'deductRate') {
          this.sortKeyWord = 3;
        }
      }
      this.getTableData(this.pageNum, JSON.parse(window.sessionStorage.getItem('selectDate')));
    },
    // 获取表格数据
    getTableData(val, e) {
      const data = {
        // startTime: this.time ? this.time[0] : null,
        // endTime: this.time ? this.time[1] : null,
        startTime: e.beginTime,
        endTime: e.endTime,
        dateType: e.dateType,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: val,
        pageSize: this.pageSize,
        sortKeyWord: this.sortKeyWord,
        sortType: this.sortType
      };
      api.getVipCardsDeduct(data).then((res) => {
        this.tableData = res.data ? res.data.records ? res.data.records : [] : [];
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].num = 0;
          this.tableData[i].Pnum = 0;
          for (let n = 0; n < this.tableData[i].itemList.length; n++) {
            this.tableData[i].num += this.tableData[i].itemList[n].count;
          }
          for (let m = 0; m < this.tableData[i].productList.length; m++) {
            this.tableData[i].Pnum += this.tableData[i].productList[m].productCount;
          }
        }
        this.rowCount = res.data.total;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getTableData(this.pageNum, JSON.parse(window.sessionStorage.getItem('selectDate')));
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableData(this.pageNum, JSON.parse(window.sessionStorage.getItem('selectDate')));
    },
    // 修改日期
    onChangeTime(e) {
      this.getTableData(this.pageNum, e);
    },
    // 套餐划扣详情
    details(val, vipCardName) {
      const data = {
        startTime: this.time ? this.time[0] : null,
        endTime: this.time ? this.time[1] : null,
        vipCardId: val,
        mainId: sessionStorage.getItem('mainId'),
      };
      api.getVipCardAnalyse(data).then((res) => {
        if (res.code === 0) {
          this.PackageData = res.data;
          this.vipCardName = vipCardName;
          this.PackageDialog = true;
        }
      });
    },
    // 调用公共组件--赋值
    getDialogData(list) {
      this.PackageDialog = list;
    },
    // 导出表格
    onDownload() {
      if (this.Lib.checkPower('beauty-4-dctchkfx') == false) return;
      const item = JSON.parse(window.sessionStorage.getItem('selectDate'));
      this.$root.$children[0].fatherExport('exportVipCardDeduct', item.beginTime, item.endTime, this.sortKeyWord, this.sortType, item.dateType, sessionStorage.getItem('mainId'),);
    },
    // 网页打印
    onPrint() {
      if (this.Lib.checkPower('beauty-4-dytchkfx') == false) return;
      this.$print({
        data: this.tableData,
        table_tol: [
          {
            prop: 'vipCardName',
            name: '套餐名称'
          },
          {
            prop: 'num',
            name: '包含项目产品数量'
          },
          {
            prop: 'vipCardPrice',
            name: '套餐价格'
          },
          {
            prop: 'duringSellNum',
            name: '期间销售量'
          },
          {
            prop: 'earlySellNum',
            name: '期初未划扣总数'
          },
          {
            prop: 'duringQualityNum',
            name: '期间套餐内总数'
          },
          {
            prop: 'duringDeductNum',
            name: '期间划扣总数'
          },
          {
            prop: 'lastSellNum',
            name: '期末剩余未划扣总数'
          }
        ],
        title: '套餐划扣'
      });
    },
  }
};
</script>
<style>
.btnL {
    float: right;
}
</style>
